import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { classNames } from 'uitk-react-utils';

import { Action, Logo, Message, useBannersContext } from 'features/banners';

function Panel(): JSX.Element {
  const { formatText } = useLocalization();
  const { messageId } = useBannersContext();

  const hasMessage = Boolean(formatText(`product.banners.message.content.${messageId}`));

  const panelClassName = classNames('panel', { 'panel--no-message': !hasMessage });

  return (
    <section className={panelClassName}>
      <div className="panel__logo">
        <Logo />
      </div>

      {hasMessage && (
        <div className="panel__message">
          <Message />
        </div>
      )}

      <div className="panel__action">
        <Action />
      </div>
    </section>
  );
}

export { Panel };
